module.exports = __webpack_public_path__ + "img/linkedin.25f408f6.jpg";